// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2pLZC","author":"Table_author__3XJT_","authorImage":"Table_authorImage__2nXgz","unreadRow":"Table_unreadRow__3pWvV"};